module.exports = __webpack_public_path__ + "media/notice4.e75bac51.mp3";